var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var InputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: ", ";\n    flex-direction: ", ";\n    align-items: ", ";\n\n    /* More preference is given to error color. */\n    border: ", ";\n\n    border-radius: ", ";\n"], ["\n    display: ", ";\n    flex-direction: ", ";\n    align-items: ", ";\n\n    /* More preference is given to error color. */\n    border: ", ";\n\n    border-radius: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.style.display.flex;
}, function (_a) {
    var theme = _a.theme;
    return theme.style.flexDirection.row;
}, function (_a) {
    var theme = _a.theme;
    return theme.style.alignItems.center;
}, function (_a) {
    var hasError = _a.hasError, hasWarning = _a.hasWarning, theme = _a.theme;
    return "solid " + theme.typography.border.width.xxxThin + " " + (hasError
        ? theme.colors.tfwErrorRed
        : hasWarning
            ? theme.colors.tfwWarning
            : theme.colors.tfwDefaultInputBorder);
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.border.radius.small;
});
export var InputField = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n\n    /* More preference is given to error color. */\n    color: ", ";\n\n    background-color: ", ";\n    padding: ", ";\n    border: 0;\n    outline: 0;\n    width: 100%;\n\n    /* This border radius needs to be in sync with the border radius of the container. */\n    border-radius: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n\n    /* More preference is given to error color. */\n    color: ", ";\n\n    background-color: ", ";\n    padding: ", ";\n    border: 0;\n    outline: 0;\n    width: 100%;\n\n    /* This border radius needs to be in sync with the border radius of the container. */\n    border-radius: ", ";\n"])), function (_a) {
    var fontFamily = _a.fontFamily, theme = _a.theme;
    return fontFamily || theme.typography.font.family.lato;
}, function (_a) {
    var fontSize = _a.fontSize, theme = _a.theme;
    return fontSize || theme.typography.font.size.medium;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight || '1';
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight || '400';
}, function (_a) {
    var fontColor = _a.fontColor, hasError = _a.hasError, hasWarning = _a.hasWarning, theme = _a.theme;
    return hasError
        ? theme.colors.tfwErrorRed
        : hasWarning
            ? theme.colors.tfwWarning
            : fontColor || theme.colors.tfwBlack87;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var padding = _a.padding, theme = _a.theme;
    return padding !== null && padding !== void 0 ? padding : theme.spacing.small;
}, function (_a) {
    var borderRadius = _a.borderRadius, theme = _a.theme;
    return borderRadius || theme.typography.border.radius.small;
});
var templateObject_1, templateObject_2;
